import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../settings';
import KioskSettingsAddPage from '@/features/kiosk/pages/KioskSettingsAddPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/add',
  component: KioskSettingsAddPage,
});
